import { useTranslation } from "react-i18next";
import RenewalHeader from "./RenewalHeader";
import { windowScroll } from "../../../helpers/shared/useNavigationEffects";
import { useEffect } from "react";
import ContentSection from "./components/ContentSection";
import { Footer } from "../../tpa/components/Footer";

const RenewalLinkExpire = () => {
  const { t } = useTranslation("pages", { keyPrefix: "travel.payNow.renewalLinkExpire" });
  const { t: footer } = useTranslation("pages", { keyPrefix: "travel.payNow.sgFooter" });
  //renewal Link Expire Page
  useEffect(() => {
    windowScroll();
  });
  return (
    <div className="flex flex-col min-h-screen gap-0">
      <RenewalHeader />
      <ContentSection t={t} />
      <Footer footer={footer} />
    </div>
  );
};

export default RenewalLinkExpire;
